import { render, staticRenderFns } from "./DeleteUserConfirmation.vue?vue&type=template&id=30155434&scoped=true&"
import script from "./DeleteUserConfirmation.vue?vue&type=script&lang=js&"
export * from "./DeleteUserConfirmation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30155434",
  null
  
)

export default component.exports